import React from 'react';
import './ScrollProgress.css';

export default function ScrollProgress() {
  return <div className="scroll-progress" data-progress aria-hidden="true" />;
}
